import {Component, Inject, OnInit, Optional} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBar} from '@angular/material/snack-bar';
import {SnackBarDataInjectedInterface} from 'fuse-core/news/snackbar/snack-bar-data-injected.interface';

@Component({
    selector: 'app-old-learner-start-lessons',
    templateUrl: './old-learner-start-lessons.component.html',
    styleUrls: ['./old-learner-start-lessons.component.scss'],
    standalone: false
})
export class OldLearnerStartLessonsComponent implements OnInit {
    constructor(private snackbar: MatSnackBar, @Optional() @Inject(MAT_SNACK_BAR_DATA) public data: SnackBarDataInjectedInterface) {
    }

    onClick() {
        this.snackbar.dismiss();
    }

    ngOnInit(): void {
    }

}